import template from '../../../../../../ui-formly/partials/form.html'
import FormControllerFactory from '../../../../../../ui-formly/controllers/FormControllerFactory'
import fields from './formly'
import { vsNgType as CommonMachineServerName } from '../../../../Server'

export const vsName = 'machineCommissionProgramEdit'
export const vsNgType = 'directive'

machinesCommissionProgramEdit.$inject = [CommonMachineServerName]
export function machinesCommissionProgramEdit(CommonMachineServer) {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {
      model: '='
    },
    controller: FormControllerFactory({
      returnState: '^.main',
      formFields: fields(CommonMachineServer),
      submit: CommonMachineServer.programSave
    }),
    controllerAs: 'ctrl',
    bindToController: true
  }
}
